// @flow
import React from 'react';
import Flex from '@waglabs/flex';
import H2 from '@waglabs/h2';

import { BodyContainer } from '../../../BodyContainer';
import { Instructions, type InstructionsData } from './components/Instructions';

type HowItWorksData = InstructionsData;

type Props = {
  data: HowItWorksData,
  sectionTitle: string,
};

export const HowItWorks = ({
  data,
  sectionTitle,
}: Props) => (
  <Flex
    alignItems="center"
    bg="backgroundGray"
    boxSizing="border-box"
    flexDirection="column"
    justifyContent="center"
    pt={[4, 5, 0]}
    pb={2}
    mb={4}
    width={1}
  >
    <BodyContainer>
      <H2
        color="medGray"
        fontFamily="bodyMuli"
        fontSize={[8, 9, 10]}
        fontWeight="bold"
        mt={[0, 0, '42px']}
      >
        {sectionTitle}
      </H2>
      <Flex
        boxSizing="border-box"
        flexDirection={['column', 'column', 'row']}
        justifyContent="center"
        mb={[0, 3]}
        width={1}
      >
        <Instructions values={data} />
      </Flex>
    </BodyContainer>
  </Flex>
);
